import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { heart } from 'ionicons/icons';
import {
  NgcCookieConsentService,
  NgcInitializationErrorEvent,
  NgcInitializingEvent,
  NgcNoCookieLawEvent,
  NgcStatusChangeEvent,
} from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { NavbarComponent } from './core/layout/navbar/navbar.component';
import { UpdateCheckService } from './shared/services/update-check.service';
@Component({
  selector: 'app-root',
  imports: [
    IonRouterOutlet,
    //IonSplitPane,
    IonApp,
    NavbarComponent,
    //MenuComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  ccService = inject(NgcCookieConsentService);
  private updateCheckService = inject(UpdateCheckService);
  private meta = inject(Meta);

  private popupOpenSubscription!: Subscription;
  private popupCloseSubscription!: Subscription;
  private initializingSubscription!: Subscription;
  private initializedSubscription!: Subscription;
  private initializationErrorSubscription!: Subscription;
  private statusChangeSubscription!: Subscription;
  private revokeChoiceSubscription!: Subscription;
  private noCookieLawSubscription!: Subscription;

  constructor() {
    addIcons({ heart });
  }

  ngOnInit() {
    if (!environment.production) {
      this.meta.addTag({
        name: 'robots',
        content: 'noindex, nofollow',
      });
    }

    // Inicializar monitoramento de atualizações do PWA
    this.updateCheckService.initializeAutoUpdate();

    this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(() => {});

    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
      () => {},
    );

    this.initializingSubscription = this.ccService.initializing$.subscribe(
      (event: NgcInitializingEvent) => {
        console.log(`initializing: ${JSON.stringify(event)}`);
      },
    );

    this.initializedSubscription = this.ccService.initialized$.subscribe(
      () => {},
    );

    this.initializationErrorSubscription =
      this.ccService.initializationError$.subscribe(
        (event: NgcInitializationErrorEvent) => {
          console.log(
            `initializationError: ${JSON.stringify(event.error?.message)}`,
          );
        },
      );

    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {},
    );

    this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
      () => {},
    );

    this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
      (event: NgcNoCookieLawEvent) => {},
    );
  }

  ngOnDestroy() {
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializingSubscription.unsubscribe();
    this.initializedSubscription.unsubscribe();
    this.initializationErrorSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }
}
